import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import Switch from 'react-switch';
import { reactSwitch } from '../../../../constants/ui';

export default class SwitchRow extends PureComponent {
  render () {
    const { onChange, checked, color, width, height, label, disabled } = this.props;

    return (
      <div className={`d-flex align-items-center ${disabled ? 'ui-disabled' : ''}`}>
        <Switch
          onChange={onChange}
          checked={checked}
          onColor={color}
          uncheckedIcon={false}
          checkedIcon={false}
          width={width}
          height={height}
        />
        {label && (
          <div className='label ml-2 pointer' onClick={onChange}>{label}</div>
        )}
      </div>
    );
  }
}

SwitchRow.propTypes = {
  onChange: PropTypes.func.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string,
  color: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  disabled: PropTypes.bool
};

SwitchRow.defaultProps = {
  ...reactSwitch,
  disabled: false
};



// WEBPACK FOOTER //
// ./src/components/common/forms/SwitchRow/index.js